import request, { apiURL, getRequestOptions } from '../utils/api';

/**
 * ENG-30935 — client for the Lead Management funnel read API.
 *
 * Three read-only endpoints, all scoped to the selected property and gated
 * server-side by the Prospect - Read permission:
 *   GET /{organizationId}/{propertyId}/lead-management/stages
 *   GET /{organizationId}/{propertyId}/lead-management/counts
 *   GET /{organizationId}/{propertyId}/lead-management/stage/{stageKey}/leads
 */

const base = (organizationId, propertyId) =>
  `${apiURL}/${organizationId}/${propertyId}/lead-management`;

const getOptions = () => ({ method: 'GET', ...getRequestOptions() });

class LeadManagementService {
  getStages(organizationId, propertyId) {
    return request(`${base(organizationId, propertyId)}/stages`, getOptions());
  }

  getCounts(organizationId, propertyId) {
    return request(`${base(organizationId, propertyId)}/counts`, getOptions());
  }

  getStageLeads(organizationId, propertyId, stageKey, page = 1, pageSize = 25) {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });
    return request(
      `${base(organizationId, propertyId)}/stage/${encodeURIComponent(
        stageKey,
      )}/leads?${params}`,
      getOptions(),
    );
  }
}

export default LeadManagementService;
